import { useEffect, useState } from "react"
import api from "../api-client"
import { Link, Section, SelectedLoanTerm } from "../components"
import { toast } from "react-toastify"
import { errorToString, StatusData, EquifaxDitReport, CreditReportItem, jsonToCreditItem } from "@oneethos/shared"
import { Spinner, SpinnerSize } from "@fluentui/react"
import { useParams } from "react-router-dom"
import { useAppState } from "../hooks"

export const CreditReportPage = () => {
  const [loading, setLoading] = useState(true)
  const { id } = useParams()
  const { tenant } = useAppState()
  const [creditItem, setCreditItem] = useState(null)
  const [project, setProject] = useState<StatusData | null>(null)

  const doSearch = () => {
    setLoading(true)
    api.get(`/credit-reports/${id}`).then(res => {
      const ci = jsonToCreditItem(res)
      setCreditItem(ci)

      if (ci.item.loanAppId) {
        api.getProject(ci.item.loanAppId).then(setProject)
          .catch(ex => toast.error(errorToString(ex), { autoClose: false }))
      }
    }).catch(ex => toast.error(errorToString(ex))).finally(() => setLoading(false))
  }

  useEffect(() => {
    doSearch()
  }, [])

  return (
    <Section>      
      {project?.loanDurationMonths ? <>
        <h6 className="mt-4">Customer's Selected Loan Term</h6>
        <SelectedLoanTerm
          project={project}
          tenant={tenant}
          onChange={setProject}
          hideDisclaimer
        />
      </> : null}

      {loading ? <Spinner size={SpinnerSize.large} /> : <>
        {creditItem.item.type !== 'dit' ? (
          <CreditReportItem
            report={creditItem.report}
            item={creditItem.item}
          />
        ) : <EquifaxDitReport item={creditItem.item} />}
      </>
      }
    </Section>
  )
}


export default CreditReportPage